/**
 * @ngdoc object
 * @name bo.objects.controller:BoOptionEditController
 *
 * @description
 *
 */
import {AbstractEditorController} from './abstract-editor-controller';

class BoOptionEditController extends AbstractEditorController {

    constructor($injector) {
        super($injector);
        this.queue = this.injector.get('$q');

        this.model = {
            meta: {},
            meta_translated: {}
        };
        this.typeSelectionDisabled = true;

        this.headline = 'Edit Bookable-object';

        this.queue.all([
            this._loadObject(),
            this._loadOption(),
            this._loadAvailableTypes()
        ]).then(() => {
            this._updateNavigation();
        });
    }

    _updateNavigation() {
        super._updateNavigation();
        if (!this.model) {
            return;
        }

        this.navHelper.setTranslationsParamsForEntry('settings.custom_defaults.bo-objects.details.options.details', {
            name: this.model.label
        });
    }

    save() {
        this.api.put(`bo/objects/${this.objectModel.id}/options/${this.model.id}`, this._prepareModelForApi()).then(() => {
            this.growl.success('Option was saved successful', {title: 'Success'});
            this.cancel();
        }, () => {
            this.growl.error('Please try again', {title: 'Save error'});
        });
    }

    cancel() {
        this.state.go('app.bo.options.details', {
            id: this.model.id,
            objectId: this.objectModel.id
        })
    }
}

angular
    .module('festzelt-os.modules.bo.objects')
    .controller('BoOptionEditController', BoOptionEditController);



// WEBPACK FOOTER //
// ./src/app/modules/bo/options/controllers/edit-controller.js